import moment from 'moment-timezone';

import { getMonthsBetween } from '../../VisitsScheduling/calendar/utils';
import { Episode } from './types';

/**
 * Get the end date for an episode, calculating it if not provided
 * Episodes 1-2 are 90 days, others are 60 days
 */
export const getEpisodeEndDate = (episode: Episode) => {
    let episodeLength = 60;
    if (episode.numberInSequence && episode.numberInSequence <= 2) {
        episodeLength = 90;
    }
    return episode.endDate ?? moment(episode.startDate).add(episodeLength, 'days').toDate();
};

export const getMonthsInRange = (episode: Episode): Date[] => {
    if (!episode.startDate) {
        return [new Date()];
    }
    return getMonthsBetween(episode.startDate, getEpisodeEndDate(episode));
};
